import Spinner from '@/assets/svg/Spinner';
import {useAppRates} from '@/context/AppRatesContext';
import type {UserType} from '@/types';
import {convertOrderedRatesListToMap} from '@/utils/rates/convertRatesListToMap';

import RatesTable from './RatesTable';

type RatesListProps = {
  target?: UserType;
  /** Test hook prefix; the loader and the table namespace under it. */
  dataCy?: string;
};
const RatesList = ({target = 'AFRIEX', dataCy}: RatesListProps) => {
  const {state} = useAppRates();
  const rateList =
    target === 'BUSINESS' ? state.businessRateList : state.rawAppRates;
  const appRates = convertOrderedRatesListToMap(rateList);
  return (
    <>
      {state.loading ? (
        <div
          data-cy={dataCy ? `${dataCy}-loading` : undefined}
          className="w-full flex pt-5 sm:pt-10 justify-center"
        >
          <Spinner size={8} className="text-cyan-700" />
        </div>
      ) : (
        <div className="p-4">
          <RatesTable
            rates={appRates}
            dataCy={dataCy ? `${dataCy}-table` : undefined}
          />
        </div>
      )}
    </>
  );
};

export default RatesList;
